import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TemplateDashboard\SetFieldTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/SetFieldTemplateDashboardController.php
* @route '/api/template-dashboard-set-field/{template_dashboard}'
*/
const SetFieldTemplateDashboardController = (args: { template_dashboard: string | number | { id: string | number } } | [template_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: SetFieldTemplateDashboardController.url(args, options),
    method: 'put',
})

SetFieldTemplateDashboardController.definition = {
    methods: ["put"],
    url: '/api/template-dashboard-set-field/{template_dashboard}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\TemplateDashboard\SetFieldTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/SetFieldTemplateDashboardController.php
* @route '/api/template-dashboard-set-field/{template_dashboard}'
*/
SetFieldTemplateDashboardController.url = (args: { template_dashboard: string | number | { id: string | number } } | [template_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { template_dashboard: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { template_dashboard: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            template_dashboard: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        template_dashboard: typeof args.template_dashboard === 'object'
        ? args.template_dashboard.id
        : args.template_dashboard,
    }

    return SetFieldTemplateDashboardController.definition.url
            .replace('{template_dashboard}', parsedArgs.template_dashboard.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboard\SetFieldTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/SetFieldTemplateDashboardController.php
* @route '/api/template-dashboard-set-field/{template_dashboard}'
*/
SetFieldTemplateDashboardController.put = (args: { template_dashboard: string | number | { id: string | number } } | [template_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: SetFieldTemplateDashboardController.url(args, options),
    method: 'put',
})

export default SetFieldTemplateDashboardController